export enum RESTRICTION_GROUP {
  MONETARY = 'Monetario',
  DELEGATION = 'Delegación de poderes',
}

export enum MONETARY_UNIT {
  CLP = 'CLP',
  UF = 'UF',
}

export enum DELEGATION_UNIT {
  ONE = 1,
  TWO = 2,
}
export type MonetaryRestriction = {
  type: RESTRICTION_GROUP.MONETARY;
  values: Array<{
    value: MONETARY_UNIT;
    displayName: string;
    defaultValue: string;
  }>;
};

type DelegationRestriction = {
  type: RESTRICTION_GROUP.DELEGATION;
  values: Array<{
    value: DELEGATION_UNIT;
    displayName: string;
    defaultValue: string;
  }>;
};

export type RestrictionUnit = MonetaryRestriction | DelegationRestriction;

export const RESTRICTION_UNITS: RestrictionUnit[] = [
  {
    type: RESTRICTION_GROUP.MONETARY,
    values: [
      {
        value: MONETARY_UNIT.CLP,
        displayName: 'Pesos Chilenos',
        defaultValue: null,
      },
      {
        value: MONETARY_UNIT.UF,
        displayName: 'Unidades de Fomento',
        defaultValue: null,
      },
    ],
  },
  {
    type: RESTRICTION_GROUP.DELEGATION,
    values: [
      {
        value: DELEGATION_UNIT.ONE,
        displayName: '1',
        defaultValue: 'clausula administrador',
      },
      {
        value: DELEGATION_UNIT.TWO,
        displayName: '2',
        defaultValue: 'clausula administrador y clausula gerente general',
      },
    ],
  },
];
